import { setupPremiumDocumentHandler } from './premium-document-handler';

setupPremiumDocumentHandler();

export {
    DocumentColumn,
    DocumentColumnOptions
} from './document-column';
export {
    DOCUMENT_GRID_LOADED_EVENT_NAME,
    DOCUMENTS_LOADED_EVENT_NAME,
    DocumentGrid,
    DocumentGridOptions
} from './document-grid';
export {
    CUSTOM_KEY_METRIC,
    DEFAULT_KEY_METRIC,
    KeyMetric,
    isValidKeyMetric
} from './key-metric';
export {
    VisualizationType,
    getVisualization,
    isValid as isValidVisualizationType
} from './visualization-type';
